import { ControlPoint as NewRowIcon, Settings as OptionsIcon } from '@mui/icons-material';
import { useCallback, useRef, useState } from 'react';
import { WatchlistRowOptionsPopup } from './WatchlistComponents';
import { ButtonStyle, FooterPopupGroupStyle } from './WatchlistStyles';
import { WatchlistEntryOptions } from './WatchlistTypes';

/*

Button to add a new watch

*/

interface WatchlistFooterProps {
  isPopupOpen: boolean;
  setPopupOpen: (isOpen: boolean) => void;
  defaultOptions: WatchlistEntryOptions;
  onUpdateDefaultOptions: (options: Partial<WatchlistEntryOptions>) => void;
}

const optionsPopupAriaId = 'options-popup';
const FooterButtonStyle = { ...ButtonStyle, display: 'block', width: '100%', height: '100%' };

export const addNewRowButtonID = 'add-watch-item-button';
export const defaultOptionsButtonID = 'watchlist-default-options-button';

export const WatchlistFooter = (props: WatchlistFooterProps) => {
  const [isEditOptionsPopupOpen, setIsEditOptionsPopupOpen] = useState(false);
  const optionsAnchor = useRef<HTMLDivElement | null>(null);

  const showAddWatchPopup = () => {
    props.setPopupOpen(!props.isPopupOpen);
  };

  const showOptionsPopup = useCallback((isOpen: boolean) => {
    setIsEditOptionsPopupOpen(isOpen);
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '4rem', pointerEvents: 'none' }}>
      <div style={{ ...FooterPopupGroupStyle, right: '10px' }} title="Add New Watch">
        <NewRowIcon sx={FooterButtonStyle} onClick={showAddWatchPopup} role={'button'} data-testid={addNewRowButtonID} />
      </div>
      <div ref={optionsAnchor} style={{ ...FooterPopupGroupStyle, left: '10px' }} title={'Default Options'} data-testid={defaultOptionsButtonID}>
        <OptionsIcon
          sx={FooterButtonStyle}
          onClick={() => {
            showOptionsPopup(!isEditOptionsPopupOpen);
          }}
          aria-owns={optionsPopupAriaId}
          role={'button'}
        />
        <WatchlistRowOptionsPopup
          onUpdateOption={props.onUpdateDefaultOptions}
          anchorEl={optionsAnchor}
          open={isEditOptionsPopupOpen}
          options={props.defaultOptions}
          setIsOpen={setIsEditOptionsPopupOpen}
          title="Default Watchlist Options"
          hideOnMouseOut={true}
        />
      </div>
    </div>
  );
};
